import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import CalculatorPage from "@/pages/CalculatorPage";
import ContactPage from "@/pages/ContactPage";
import CreditGuidePage from "@/pages/CreditGuidePage";
import TermsPage from "@/pages/TermsPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App bg-background min-h-screen">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/how-it-works" element={<HowItWorksPage />} />
                        <Route path="/home-loans" element={<ServiceDetailPage slug="home-loans" />} />
                        <Route path="/first-home-buyer" element={<ServiceDetailPage slug="first-home-buyer" />} />
                        <Route path="/refinance" element={<ServiceDetailPage slug="refinance" />} />
                        <Route path="/investment-loans" element={<ServiceDetailPage slug="investment-loans" />} />
                        <Route path="/commercial-loans" element={<ServiceDetailPage slug="commercial-loans" />} />
                        <Route path="/self-employed-loans" element={<ServiceDetailPage slug="self-employed-loans" />} />
                        <Route path="/car-asset-finance" element={<ServiceDetailPage slug="car-asset-finance" />} />
                        <Route path="/personal-loans" element={<ServiceDetailPage slug="personal-loans" />} />
                        <Route path="/calculator" element={<CalculatorPage />} />
                        <Route path="/blog" element={<BlogListPage />} />
                        <Route path="/blog/:slug" element={<BlogPostPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/credit-guide" element={<CreditGuidePage />} />
                        <Route path="/privacy" element={<CreditGuidePage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster richColors position="top-right" />
            </BrowserRouter>
        </div>
    );
}

export default App;
